import type { Component } from 'vue'
import { createApp } from 'vue'

import { setupDirectives } from '@/directives'
import { setupElementPlus } from '@/plugins/element-plus'
import { setupErrorHandler, setupGlobalErrorHandler } from '@/plugins/error-handler'
import { setupNetworkStatus } from '@/plugins/network-status'
import router from '@/router'
import { setupRouterGuards } from '@/router/guards'
import pinia, { useAppStore, useSettingsStore, useUserStore } from '@/store'
import { UserRole } from '@/types/auth'
import { setupDevTools } from '@/utils/cleanStorage'
import App from './App.vue'

import './styles/fonts.css'
import './styles/typography-overrides.css'
import './styles/index.scss'
import 'virtual:uno.css'

async function initializeApp() {
  const app = createApp(App as Component)

  setupGlobalErrorHandler()
  setupErrorHandler(app)
  setupNetworkStatus()
  setupDevTools()

  app.use(pinia)
  app.use(router)
  setupRouterGuards(router)
  setupElementPlus(app)
  setupDirectives(app)

  app.mount('#app')

  const appStore = useAppStore()
  const settingsStore = useSettingsStore()
  const userStore = useUserStore()

  appStore.initDeviceDetection()
  settingsStore.initSettings()
  appStore.setTitle('专业3D模型分享与众包任务平台')

  if (userStore.token && userStore.userInfo) {
    if (import.meta.env.DEV) {
      // console.log('[init] restored user session')
    }

    const userInfo = userStore.userInfo

    if (userInfo?.role && !(Object.values(UserRole) as string[]).includes(userInfo.role)) {
      // console.warn('[init] invalid role detected, fixing to USER:', userInfo.role)
      userStore.setUserInfo({ ...userInfo, role: UserRole.USER })
    }

    if (import.meta.env.DEV) {
      // console.log('[init] user state', {
      //   isLoggedIn: userStore.isLoggedIn,
      //   role: userStore.userInfo?.role,
      //   hasToken: !!userStore.token,
      // })
    }
  }

  if (import.meta.env.DEV) {
    // console.log('[init] app ready')
  }
}

initializeApp().catch((_error) => {
  // console.error('[init] app init failed', error)
})
